export default __webpack_public_path__ + "static/media/phonicsPreviewPic.156798e8.webp";